function initEnv() {
    const subdomain = window.location.hostname.split('.')[0];
    const regularDomains = ['localhost'];
    if (!regularDomains.includes(subdomain) && isNaN(Number(subdomain))) {
        this.subdomain = subdomain;
    }
}

export default initEnv;
